import type { ResourceConfig } from "../types";

/**
 * 知识标签权限配置 (Spec 056)
 */
export const knowledgeTagConfig = {
  displayName: "知识标签",
  category: "knowledge",
  permissions: {
    "read:all": {
      label: "查看所有标签",
      description: "可以查看所有知识标签",
    },
    "write:all": {
      label: "管理标签",
      description: "可以创建和编辑知识标签",
    },
    "delete:all": {
      label: "删除标签",
      description: "可以删除知识标签（仅管理员）",
    },
  },
} satisfies ResourceConfig;
